var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("canvas", {
        ref: "canvas",
        staticClass: "mainCanvas",
        attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
      }),
      _vm._v(" "),
      _vm.addressModel
        ? _c("DrawView", {
            key: _vm.componentKey,
            attrs: {
              "address-model": _vm.addressModel,
              "bleed-margin": _vm.bleedMargin,
              "page-model": _vm.pageModel,
              scaling: _vm.scaling,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }